import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Checkbox,
    FormControlLabel,
    IconButton,
    InputAdornment,
    Skeleton,
    TextField,
    Theme,
    Typography,
} from '@mui/material';
import {
    AccordianMinusIcon,
    AccordianPlusIcon,
    BlackExitIcon,
    BlueTickIcon,
    CheckIcon,
    DialogCloseIcon,
    InvertedDrakDropDownIcon,
    SearchIcon,
    UnCheckIcon
} from '../../../assets/SvgIcons';
import { useState } from 'react';
import {
    CustomFilterProps,
    FilterCheckboxProps,
    TableHeaderData,
} from '../types';
import {
    notificationFilter,
} from '../../../redux-store/types/investorProfile';
import { ProductTypeFilter, TransactionTypeFilter, PaymentTypeFilter } from '../../../redux-store/types/orderManagement';
import { useLocation } from 'react-router';

function FilterCheckbox({
    value,
    label,
    checked,
    handleChange
}: FilterCheckboxProps) {
    return (
        <FormControlLabel
            value={value}
            control={
                <Checkbox
                    size="small"
                    checkedIcon={<CheckIcon />}
                    icon={<UnCheckIcon />}
                    sx={{
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                    }}
                    checked={checked}
                    onChange={handleChange}
                />
            }
            label={
                <Typography
                    variant="body_500"
                    sx={(theme: Theme) => ({
                        color: theme.palette.text.primary,
                        wordBreak: "break-all"
                    })}>
                    {label}
                </Typography>
            }
            sx={{ display: 'flex' }}
        />
    );
}

const FilterLoader = () => {
    return (
        <Box
            sx={{
                marginTop: '25px',
                display: "flex",
                flexDirection: "column",
                rowGap: "10px"
            }}
        >
            {[...Array(5)].map((_, index) => (
                <Skeleton
                    key={index}
                    animation="wave"
                    variant="rounded"
                    height={35}
                />
            ))}
        </Box>
    )
};

interface CustomNotificationFilterProps {
    isLoading?: boolean;
    handleClearAll?: () => void;
    showRmFilter?: boolean;
    rmFilterData?: any[];
    showCategoryFilter?: boolean;
    categoryFilterData?: any;
    showInvestorFilter?: boolean;
    InvestorFilterData?: any;
    handleApplyFilters?: () => void;
    handleRmFilterChange?: (value: string, checked: boolean) => void;
    handleCategoryFilterChange?: (value: string, checked: boolean) => void;
    handleInvestorFilterChange?: (value: string, checked: boolean) => void;
    showCloseIcon?: boolean;
    handleCloseIconClick?: () => void;
    isFilterApplied?: boolean;
    defaultExpandedFilter?: string;
    showApplyButton?: boolean;
    handleInvestorSearch?: (value: string) => void;
}
export default function CustomNotificationFilter({
    isLoading = false,
    handleClearAll,
    showRmFilter = true,
    rmFilterData = [],
    showCategoryFilter = true,
    categoryFilterData = {},
    showInvestorFilter = true,
    InvestorFilterData = {},
    handleApplyFilters = () => { return; },
    handleRmFilterChange = () => { return; },
    handleCategoryFilterChange = () => { return; },
    handleInvestorFilterChange = () => { return; },
    showCloseIcon = false,
    handleCloseIconClick = () => { return; },
    isFilterApplied = false,
    defaultExpandedFilter = "",
    showApplyButton = true,
    handleInvestorSearch = () => { return; },
}: CustomNotificationFilterProps): JSX.Element {

    const { pathname } = useLocation();

    return (
        <Box>
            <Box
                sx={(theme: Theme) => ({
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    paddingBottom: '20px',
                    borderBottomWidth: '0.7px',
                    borderBottomStyle: 'solid',
                    borderBottomColor: `${theme.palette.text.secondary}B2`,
                })}>
                <Typography variant="h2" sx={(theme: Theme) => ({ color: theme.palette.text.primary })}>
                    Filters
                </Typography>
                <Box sx={{ display: "flex", columnGap: "10px" }}>
                    {showApplyButton && (
                        <Button
                            variant="outlined"
                            sx={
                                (theme: Theme) => ({
                                    color: theme.palette.textDark.primary,
                                    backgroundColor: theme.palette.primary[500],
                                    ...theme.typography.body_500,
                                    padding: "5px",
                                    border: "none",
                                    '&:hover': {
                                        backgroundColor: theme.palette.primary[500],
                                        color: theme.palette.textDark.primary
                                    },
                                })
                            }
                            onClick={handleApplyFilters}
                            disabled={isLoading}
                        >
                            Apply
                        </Button>
                    )}
                    <Button
                        variant="text"
                        sx={(theme: Theme) => ({
                            ...theme.typography.body_500,
                            color: theme.palette.primary[500],
                            padding: "5px"
                        })}
                        onClick={handleClearAll}
                        // disabled={isLoading || !isFilterApplied}
                        disabled={isLoading}
                    >
                        Clear All
                    </Button>
                    {showCloseIcon &&
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseIconClick}
                            sx={{ padding: "5px" }}
                        >
                            <BlackExitIcon />
                        </IconButton>
                    }
                </Box>
            </Box>

            {showCategoryFilter && (
                <Box
                    sx={(theme: Theme) => ({
                        marginTop: "5px",
                        paddingBottom: '15px',
                        borderBottomWidth: '0.7px',
                        borderBottomStyle: 'solid',
                        borderBottomColor: `${theme.palette.text.secondary}B2`,
                    })}>
                    <Accordion
                        defaultExpanded={defaultExpandedFilter === "risk"}
                        sx={{ boxShadow: 'none' }}
                    >
                        <AccordionSummary
                            expandIcon={<InvertedDrakDropDownIcon />}
                            aria-controls="risk-filter"
                            id="risk-filter"
                            sx={{
                                padding: '0px',
                            }}>
                            <Typography variant="h2" sx={(theme: Theme) => ({ color: theme.palette.text.primary })}>
                                Category
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails
                            sx={{
                                padding: '0px',
                            }}>
                            {isLoading ? (
                                <FilterLoader />
                            ) : (
                                categoryFilterData?.map((obj: notificationFilter) => (
                                    <FilterCheckbox
                                        key={obj.id}
                                        value={obj.id}
                                        label={obj.label}
                                        checked={!!obj?.checked}
                                        handleChange={(event: React.ChangeEvent<HTMLInputElement>) => handleCategoryFilterChange(obj.id, event.target.checked)}
                                    />
                                )))
                            }
                        </AccordionDetails>
                    </Accordion>
                </Box>
            )}

            {showRmFilter && (
                <Box
                    sx={(theme: Theme) => ({
                        marginTop: "5px",
                        paddingBottom: '15px',
                        borderBottomWidth: '0.7px',
                        borderBottomStyle: 'solid',
                        borderBottomColor: `${theme.palette.text.secondary}B2`,
                    })}>
                    <Accordion
                        defaultExpanded={defaultExpandedFilter === "risk"}
                        sx={{ boxShadow: 'none' }}
                    >
                        <AccordionSummary
                            expandIcon={<InvertedDrakDropDownIcon />}
                            aria-controls="risk-filter"
                            id="risk-filter"
                            sx={{
                                padding: '0px',
                            }}>
                            <Typography variant="h2" sx={(theme: Theme) => ({ color: theme.palette.text.primary })}>
                                RM
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails
                            sx={{
                                padding: '0px',
                            }}>
                            {isLoading ? (
                                <FilterLoader />
                            ) : (
                                rmFilterData?.map((obj: notificationFilter) => (
                                    <FilterCheckbox
                                        key={obj.id}
                                        value={obj.id}
                                        label={obj.label}
                                        checked={!!obj?.checked}
                                        handleChange={(event: React.ChangeEvent<HTMLInputElement>) => handleRmFilterChange(obj.id, event.target.checked)}
                                    />
                                )))
                            }
                        </AccordionDetails>
                    </Accordion>
                </Box>
            )}

            {showInvestorFilter && (
                <Box
                    sx={(theme: Theme) => ({
                        marginTop: "5px",
                        paddingBottom: '15px',
                        borderBottomWidth: '0.7px',
                        borderBottomStyle: 'solid',
                        borderBottomColor: `${theme.palette.text.secondary}B2`,
                    })}>
                    <Accordion
                        defaultExpanded={defaultExpandedFilter === "investmentData"}
                        sx={{ boxShadow: 'none' }}
                    >
                        <AccordionSummary
                            expandIcon={<InvertedDrakDropDownIcon />}
                            aria-controls="investment-data-filter"
                            id="investment-data-filter"
                            sx={{ padding: '0px' }}>
                            <Typography
                                variant="h2"
                                sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
                            >
                                Investors
                            </Typography>
                        </AccordionSummary>

                        <AccordionDetails
                            sx={{ padding: '0px' }}>
                            <TextField
                                // label="Search by ID or Label"
                                placeholder='Search with Customer Id or Name..'
                                variant="outlined"
                                sx={{
                                    width: '100%',
                                    marginBottom: '10px',
                                    borderRadius: '8px',
                                    '& .MuiInputBase-root': {
                                        '& fieldset': {
                                            border: '1px solid #ccc',
                                            borderRadius: '8px',
                                            padding: '10px',
                                            transition: 'border-color 0.3s ease',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: 'rgba(0, 0, 0, 0.42)',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: 'rgba(0, 0, 0, 0.42)',
                                        },
                                    },
                                    '& .MuiInputBase-input': {
                                        padding: '8px 12px',
                                        transition: 'border-color 0.3s ease',
                                    },
                                    '& .MuiInputBase-input.Mui-focused': {
                                        borderColor: 'rgba(0, 0, 0, 0.42)',
                                    },
                                }}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    const searchValue = event.target.value;
                                    handleInvestorSearch(searchValue);
                                }}
                            />
                            {isLoading ? (
                                <FilterLoader />
                            ) : InvestorFilterData?.length > 0 ? (
                                InvestorFilterData?.map((obj: notificationFilter) => (
                                    <FilterCheckbox
                                        key={obj.id}
                                        value={obj.id}
                                        label={obj.label}
                                        checked={!!obj?.checked}
                                        handleChange={(event: React.ChangeEvent<HTMLInputElement>) => handleInvestorFilterChange(obj.id, event.target.checked)}
                                    />
                                ))) : (
                                <Typography
                                    variant='body_600'
                                    sx={(theme: Theme) => ({ color: theme.palette.text.primary, marginBottom: '10px', marginTop: '10px', display: 'block', alignItems: 'center' })}
                                >
                                    No Investor found
                                </Typography>
                            )
                            }
                        </AccordionDetails>
                    </Accordion>
                </Box>
            )}
        </Box >
    );
}
